import { AdministratorDto } from './AdministratorDto';
import { PartnershipRecyclingOptionDto } from './partnershipRecyclingOptionDto';
import { RecyclingProductDto } from './RecyclingProductDto';

export class PartnershipCompainesDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  name: string;
  phone: string;
  email: string;
  homepageUrl: string;
  isDefault: boolean;
  isUsing: boolean;
}

export class PartnershipLinksDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  startedAt: string;
  endedAt: string;
  customerCnt: number;
  isEntryAvailable: boolean;
  isDonationAvailable: boolean;
  urlCode: string;
  administrator: AdministratorDto;
  partnershipCompany: PartnershipCompainesDto;
  partnershipRecyclingOption: PartnershipRecyclingOptionDto;
  recyclingProducts: RecyclingProductDto[];
  partnershipRecyclingInfo: { id?: number; contents: string }[];
  partnershipRecyclingCaution: { id?: number; contents: string }[];
}
